import { defineStore } from "pinia";
import { ref } from "vue";
import { useRest } from "@/composables";

export const useImagenCompresionPruebaStore = defineStore("imagenCompresionPrueba", () => {
  const pruebas = ref([]);
  const resultado = ref(null);
  const isLoading = ref(false);
  const isListLoading = ref(false);
  const error = ref(null);

  const rest = useRest();

  const API_BASE = `${process.env.VUE_APP_BACKEND_ENVIRONMENT}/imagen-compresion-prueba`;

  const buildApiUrl = (path) => {
    if (!path) return "";

    if (path.startsWith("http://") || path.startsWith("https://")) {
      return path;
    }

    const cleanEnvironment = process.env.VUE_APP_BACKEND_ENVIRONMENT.replace(/\/$/, "");
    const cleanPath = path.replace(/^\//, "");

    return `${cleanEnvironment}/${cleanPath}`;
  };

  const normalizePrueba = (item) => {
    if (!item) return null;

    return {
      ...item,
      UrlOriginal: buildApiUrl(item.UrlOriginal),
      UrlOptimizada: buildApiUrl(item.UrlOptimizada),
    };
  };

  const getPruebas = async (limit = 20) => {
    isListLoading.value = true;
    error.value = null;

    try {
      const { data } = await rest.get({
        url: API_BASE,
        params: { limit },
      });

      pruebas.value = Array.isArray(data?.data)
        ? data.data.map(normalizePrueba)
        : [];

      return pruebas.value;
    } catch (e) {
      console.error("[imagenCompresionPrueba.getPruebas]", e);
      error.value = "No se pudo obtener el listado de pruebas.";
      pruebas.value = [];
      return [];
    } finally {
      isListLoading.value = false;
    }
  };

  const procesarImagen = async ({ imagen, calidad = 75, pesoObjetivoMb = 5 }) => {
    if (!imagen) {
      error.value = "Debe seleccionar una imagen.";
      return null;
    }

    isLoading.value = true;
    error.value = null;
    resultado.value = null;

    try {
      const formData = new FormData();

      formData.append("imagen", imagen);
      formData.append("calidad", String(calidad));
      formData.append("peso_objetivo_mb", String(pesoObjetivoMb));

      const { data } = await rest.post({
        url: `${API_BASE}/procesar`,
        formData,
        ContentType: "multipart/form-data",
      });

      resultado.value = normalizePrueba(data?.data ?? null);

      await getPruebas();

      return resultado.value;
    } catch (e) {
      console.error("[imagenCompresionPrueba.procesarImagen]", e);
      error.value = "No se pudo procesar la imagen.";
      return null;
    } finally {
      isLoading.value = false;
    }
  };

  const clearResultado = () => {
    resultado.value = null;
  };

  return {
    pruebas,
    resultado,
    isLoading,
    isListLoading,
    error,
    getPruebas,
    procesarImagen,
    clearResultado,
  };
});